export default {
  SPECIAL: "特殊学习需要",
  READING: "阅读",
  PARENT_SCH_COOP: "家校协作",
  WIFI: "无线网络设定及帐户管理",
  STEM: "科学、技术、工程及数学",
  ASSESSMENT: "促进学习的评估",
  RESOURCE: "教学法及教学资源",
  SELF_LEARNING: "自主学习及奖励计划",
  E_LEARNING: "电子学习趋势及创新学习",
  PROFESSIONAL: "专业发展",
};
